// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"bfe05d55","194":"42c329eb","372":"7be6b02c","480":"c89c3e5e","493":"abdb09a8","602":"47d86ec2"}[chunkId] + ".chunk.css";
};